import { useTranslation } from "react-i18next";

import styles from "./style.module.scss";

export default function MainframeSolutionInfo() {
  const { t } = useTranslation();

  return (
    <div>
      <h4>{t("mainframe")}</h4>
      <div>
        <h4>{t("aiops_auto")}</h4>
        <div className={styles.list_default}>
          {t("aiops_auto_text")}
          <ul>
            <li key="1">{t("aiops_auto_li_1")}</li>
            <li key="2">{t("aiops_auto_li_2")}</li>
            <li key="3">{t("aiops_auto_li_3")}</li>
          </ul>
        </div>
      </div>
      <div>
        <h4>{t("devops_app_dev")}</h4>
        <div className={styles.list_default}>
          {t("devops_app_dev_text")}
          <ul>
            <li key="1">{t("devops_app_dev_li_1")}</li>
            <li key="2">{t("devops_app_dev_li_2")}</li>
            <li key="3">{t("devops_app_dev_li_3")}</li>
          </ul>
        </div>
      </div>
      <div>
        <h4>{t("infrastructure")}</h4>
        <div className={styles.list_default}>
          {t("infrastructure_text")}
          <ul>
            <li key="1">{t("infra_li_1")}</li>
            <li key="2">{t("infra_li_2")}</li>
            <li key="3">{t("infra_li_3")}</li>
            <li key="4">{t("infra_li_4")}</li>
          </ul>
        </div>
      </div>
      <div>
        <h4>{t("security")}</h4>
        <div className={styles.list_default}>
          {t("security_text")}
          <ul>
            <li key="1">{t("security_li_1")}</li>
            <li key="2">{t("security_li_2")}</li>
            <li key="3">{t("security_li_3")}</li>
            <li key="4">{t("security_li_4")}</li>
            <li key="5">{t("security_li_5")}</li>
          </ul>
        </div>
      </div>
      <div>
        <h4>{t("data_manage")}</h4>
        <div className={styles.list_default}>
          {t("data_manage_text")}
          <ul>
            <li key="1">{t("data_manage_li_1")}</li>
            <li key="2">{t("data_manage_li_2")}</li>
            <li key="3">{t("data_manage_li_3")}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
